import { defineComponent as t, openBlock as s, createElementBlock as r, mergeProps as o, renderSlot as m } from "vue";
import "./ghl-ui.es219.js";
const a = t({
  name: "UIDisplaySmMedium",
  inheritAttrs: !1
}), l = t({
  ...a,
  setup(n) {
    return (e, i) => (s(), r("div", o(e.$attrs, { class: "hl-display-sm-medium" }), [
      m(e.$slots, "default")
    ], 16));
  }
}), c = l;
export {
  c as default
};
